export default function FileColumnRenderer(params,forLookup="false") {
  try{
  let value = params.data?.row_id === "+" ? [] : typeof params.value == "object" ? params.value : params.value === "+r0w" ? [] : JSON.parse(params.value || "[]");
    if(typeof params.value==="object" && params.value.hasOwnProperty("value")){
      value = typeof params.value.value == "object" ? params.value.value : params.value.value === "+r0w" ? [] : JSON.parse(params.value.value || "[]");
    }
      const temp = value.map((file, index) => {
        const ext = getFileExtension(file);
        
        if (isFileTypeImage(ext)) {
          return getImageHtml(file, params, forLookup);
        }
        return getFileIconHtml(file, params, ext);
      });
      return (
        `<div style="display: flex; align-items: center; width: ${Number(params.colDef.width)}px; height: ${params.node.rowHeight}px;">
        ${temp.join(" ")}
        </div>`
        );
    }
    catch(e){
      console.log("value is not recognisable!!");
      // return `<div>Image lost</div>`
    }
}

const getImageHtml = (file, params, forLookUp="false") => `<img alt=${file.name} forLookup=${forLookUp} class="loading_gif" src=${getImageFilePath(file, params.node.rowHeight - 5)} mode="fit" style="height: ${params.node.rowHeight - 5}px;width:${params.node.rowHeight - 5}px;margin:2px;" onload="this.style.background='none';" />`;

export const getFileIconHtml = (file, params, ext = '') => {
  return `<span alt="${file.name}" class="fiv-sqo fiv-icon-blank fiv-icon-${ext} file_icon_style" style="width: ${(params.node.rowHeight - 5)}px; height: ${params.node.rowHeight - 5}px; line-height: inherit;font-size: 10000px;margin:2px;"></span>`;
}

export function isFileTypeImage(ext) {
  return ["jpg", "jpeg", "bmp", "gif", "png"].includes(ext.toLowerCase());
}

export function getFileExtension(file) {
  const fileNameArray = (file.name ?? ".x").split('.');

  return fileNameArray[fileNameArray.length - 1];
}

export function getImageFilePath(file, height, width) {
  if (height && !file.fullpath?.includes("tigersheet.s3.amazonaws.com")) {
    if (!width) {
      width = height;
    }

    return file.fullpath + `&size=${height}x${width}`;
  }

  return file.fullpath;
}